/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Account')
    .directive('accQuotaBar', [function() {
        return {
            template: '<div class="progress quota-bar">\
                    <div class="progress-bar" role="progressbar" aria-valuenow="{{account.getQuotaPercentage()}}" aria-valuemin="0" aria-valuemax="100" ng-class="{\'almost-full\': account.isQuotaAlmostFull}" ng-style="account.quotaStyle()"></div>\
                </div>'
        }
    }]);